import React from 'react';
import { Visibility, VisibilityOff } from '@mui/icons-material';

export function PasswordField({
    value,
    setValue,
    placeholder = 'Password',
    className = 'border-light',
}) {
    const [showPassword, setShowPassword] = React.useState(false);

    return (
        <div className={`input-group mb-3 w-100 mt-3 rounded-5 overflow-hidden border border-1 ${className}`}>
            <input type={showPassword ? 'text' : 'password'}
                placeholder={placeholder} className={`form-control border border-0`}
                value={value} onChange={(e) => setValue(e.target.value)} />
            <span className="input-group-text bg-secondary" style={{ width: '45px' }} onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <VisibilityOff /> : <Visibility />}
            </span>
        </div>
    );
}